module.exports = __webpack_public_path__ + "static/media/use14_ch02.419c9339.png";